import AboutMe from "../../components/billboard_components/AboutMe"
import FieldStats from "../../components/billboard_components/FieldStats"
import HCI from "../../components/billboard_components/HCI"
import OneSmallStep from "../../components/billboard_components/OneSmallStep"
import OtherProjects from "../../components/billboard_components/OtherProjects"
import Phonici from "../../components/billboard_components/Phonici"

export const slideComponents = [
    <AboutMe />,
    <FieldStats />,
    <OneSmallStep />,
    <HCI />,    
    <Phonici />,
    <OtherProjects />,
]